import React from "react";

export function PageLoader({ children }: { children: React.ReactNode }) {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center">
      {children}
    </div>
  );
}
